import { FC } from "react";

import { useSelector } from "react-redux";
import { Outlet, useRoutes } from "react-router-dom";

import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import { RootState } from "../redux/store/store";
import { authRoutes, Routes as dashboardRoutes } from "./index";

const ModifiedMainLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

const ModifiedAuthLayout = () => {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

const AuthenticationRoutes = {
  path: "/",
  element: <ModifiedAuthLayout />,
  children: authRoutes,
};

const MainRoutes = (isAuthenticated: Boolean) => {
  return {
    path: "/",
    element: isAuthenticated ? <ModifiedMainLayout /> : <ModifiedAuthLayout />,
    children: dashboardRoutes(isAuthenticated),
  };
};

const AppRoutes: FC = () => {
  const isAuthenticated: boolean = useSelector((state: RootState) => state.auth.authStatus === true);
  return useRoutes([MainRoutes(isAuthenticated), AuthenticationRoutes]);
};

export default AppRoutes;
